<template>
  <div class="bg-login">
    <v-container fluid>
      <v-row class>
        <v-flex xs12 sm12 md4 lg4 xl4 class="align-self-center px-2 container">
          <v-container class>
            <div class="my-10">
              <v-img
                class="img-new-partner"
                src="img/rsl/saleforec.png"
              ></v-img>
            </div>
            <div class="my-5">
              <span class="font-42 font-w-600 font-Prompt">ยินดีต้อนรับ</span>
            </div>
            <div class="my-5">
              <span class="font-16 font-w-400 text-gary">
                ยินดีต้อนรับ!! โปรดกรอกข้อมูลให้ถูกต้อง
                <br />เพื่อยืนยันตัวตน
              </span>
            </div>
            <form @submit.prevent="loginFunction">
              <div class="my-5" :class="{ 'form-error': error.errorUser }">
                <v-text-field
                  class="input-login"
                  solo
                  label="ชื่อผู้ใช้งาน"
                  prepend-inner-icon="icon-USER"
                  v-model="$v.login.username.$model"
                  hint="At least 4 characters"
                ></v-text-field>
              </div>
              <div class="my-5" :class="{ 'form-error': error.errorPass }">
                <v-text-field
                  class="input-login"
                  solo
                  type="password"
                  label="รหัสผู้ใช้งาน"
                  prepend-inner-icon="icon-Lock"
                  v-model="$v.login.pass.$model"
                  hint="At least 4 characters"
                >
                </v-text-field>
              </div>
              <div class="my-5">
                <span class="round">
                  <input type="checkbox" id="checkbox" />
                  <label for="checkbox"></label>
                  <span class="font-18 font-w-400 font-Prompt mx-2"
                    >จดจำรหัสผ่าน</span
                  >
                </span>
              </div>
              <div class="my-10">
                <v-btn class="btn-login" type="submit">
                  <span class="font-24 text-w">Login</span>
                  <v-icon class="icon-font-35 text-icon-w">icon-RIGHT</v-icon>
                </v-btn>
              </div>
            </form>
          </v-container>
        </v-flex>
        <v-flex xs12 sm12 md8 lg7 xl7 class="d-pc">
          <v-container>
            <div>
              <v-img class="img-bg-login" src="img/rsl/bg-login.png"></v-img>
            </div>
          </v-container>
        </v-flex>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
export default {
  data() {
    return {
      error: {
        errorUser: false,
        errorPass: false,
      },
      login: {
        username: '',
        pass: '',
        token: '',
      },
    }
  },
  validations: {
    login: {
      username: { required, minLength: minLength(4) },
      pass: { required, minLength: minLength(4) },
    },
  },
  methods: {
    loginFunction() {
      if (!this.$v.$invalid) {
        const options = {
          url: `${this.$baseAPI}/user/public-login`,
          method: 'POST',
          data: {
            username: this.login.username,
            password: this.login.pass,
            token: this.login.token,
          },
        }
        this.$axios(options)
          .then((res) => {
            this.$store
              .dispatch('auth/getLoginNew', res.data)
              .then((result) => {
                if (result) {
                  this.$router.push('/home')
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: 'warning',
                  html: "<div style='font-weight: 500;'>ชื่อผู้ใช้ หรือ รหัสผ่านไม่ถูกต้อง</div><span style='color: #818181; font-size: 1.4rem;'>กรุณากรอกข้อมูลใหม่อีกครั้งค่ะ</span>",
                  showConfirmButton: true,
                  confirmButtonText: `ตกลง`,
                  confirmButtonColor: '#A9182A',
                })
                console.log(error)
              })
          })
          .catch((error) => {
            Swal.fire({
              icon: 'warning',
              html: "<div style='font-weight: 500;'>ชื่อผู้ใช้ หรือ รหัสผ่านไม่ถูกต้อง</div><span style='color: #818181; font-size: 1.4rem;'>กรุณากรอกข้อมูลใหม่อีกครั้งค่ะ</span>",
              showConfirmButton: true,
              confirmButtonText: `ตกลง`,
              confirmButtonColor: '#A9182A',
            })
            console.log(error)
            localStorage.removeItem('auth')
            localStorage.removeItem('shop')
            localStorage.removeItem('accessToken')
            localStorage.removeItem('token')
            localStorage.removeItem('expireTime')
          })
      } else {
        this.error.errorUser = this.$v.login.username.$invalid
        this.error.errorPass = this.$v.login.pass.$invalid
      }
    },

    loginToken() {
      const options = {
        url: `${this.$baseAPI}/user/public-login`,
        method: 'POST',
        data: {
          username: '',
          password: '',
          token: this.login.token,
        },
      }
      this.$axios(options)
        .then((res) => {
          this.$store
            .dispatch('auth/getLoginNew', res.data)
            .then((result) => {
              if (result) {
                this.$router.push('/home')
              }
            })
            .catch((error) => {
              console.log(error)
            })
        })
        .catch((error) => {
          console.log(error)
          localStorage.removeItem('auth')
          localStorage.removeItem('shop')
          localStorage.removeItem('accessToken')
          localStorage.removeItem('token')
          localStorage.removeItem('expireTime')
        })
    },

    loginCheckToken() {
      const path_url = window.location.hash
      const path_split = path_url.split('?token=')
      const path_last = path_split[path_split.length - 1]
      if (path_last != '#/') {
        this.login.token = path_last
        this.loginToken()
      }

      // const urlPath = window.location.search
      // if (urlPath != '') {
      //   const urlSearchParams = new URLSearchParams(urlPath)
      //   const params = Object.fromEntries(urlSearchParams.entries())
      //   this.login.token = params.token
      //   this.loginFunction()
      // }
    },
  },
  mounted() {
    this.loginCheckToken() // #disable
  },
}
</script>
<style scoped>
.input-login >>> .v-input__slot {
  border-radius: 10px !important;
  border: solid 1px #dcdcdc !important;
  background-color: #f9f9f9 !important;
  height: 76px !important;
}

.input-login >>> .v-text-field__slot {
  font-family: Prompt !important;
  font-size: 18px !important;
  color: #979797 !important;
}

.input-login >>> .v-input__icon i {
  font-size: 30px !important;
  color: #979797;
}

.input-login >>> .v-icon:before {
  color: #979797;
}

.round {
  display: inline-flex;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 25px;
  left: 0;
  position: relative;
  top: 0;
  width: 25px;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: '';
  height: 5px;
  left: 5px;
  opacity: 0;
  position: absolute;
  top: 8px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type='checkbox'] {
  visibility: hidden;
}

.round input[type='checkbox']:checked + label {
  background-color: #d81212;
  border-color: #d81212;
}

.round input[type='checkbox']:checked + label:after {
  opacity: 1;
}
</style>
